import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash';
import { NOT_AVAILABLE } from '../../common/constants/template.constant';

@Pipe({
  name: 'nullToNotAvailable',
})
export class NullToNotAvailablePipe implements PipeTransform {
  transform<T>(value: T): T | string {
    return isNil(value) ? NOT_AVAILABLE : value;
  }
}
